import { IRootScopeService, IScope } from "angular";
import { IModalScope } from "angular-ui-bootstrap";
import { ShareableFilter } from "@webapp/shared/unified-filters/models/shareable-filters.models";

export enum OkrViewEventType {
  OKRVIEW_VISITED = "OKRVIEW_VISITED",
  OKRVIEW_DELETED = "OKRVIEW_DELETED",
  OKRVIEW_UPDATED = "OKRVIEW_UPDATED",
}

export class OkrViewEvents {
  private $rootScope: IRootScopeService;
  constructor(private $scope: IModalScope | IScope) {
    this.$rootScope = this.$scope.$root;
  }

  public broadcastOkrViewVisited(okrView: ShareableFilter): void {
    this.$rootScope.$broadcast(OkrViewEventType.OKRVIEW_VISITED, { okrView });
  }

  public broadcastOkrViewDeleted(id: string): void {
    this.$rootScope.$broadcast(OkrViewEventType.OKRVIEW_DELETED, { id });
  }

  public broadcastOkrViewUpdated(okrView: ShareableFilter): void {
    this.$rootScope.$broadcast(OkrViewEventType.OKRVIEW_UPDATED, { okrView });
  }
}
